import type { IPublicClientApplication } from "@azure/msal-browser";
import { BACKEND_URL } from "src/hooks/useMetadata";
import { postAPI } from "src/utils/fetch";
import type { BucketSelection, FacetFilter } from "../../types";
import type { AssetRecord } from "../graph/buildAssetDocsGraph";
import { toAssetRecords } from "./toAssetRecords";

export const ASSET_MAX_RESULT = 25;

export const fetchAssets = async ({
    instance,
    index,
    filters,
    dateFilters = [],
}: {
    instance: IPublicClientApplication;
    index: string;
    filters: BucketSelection[];
    dateFilters?: FacetFilter[];
}): Promise<AssetRecord[]> => {
    const url = new URL(`v1/search/${index}/metadata/docs`, BACKEND_URL);
    url.searchParams.set("max_result", String(ASSET_MAX_RESULT));
    const response = await postAPI({
        url: url.toString(),
        instance,
        payload: [
            ...filters.map((filter) => ({ key: filter.field, value: filter.value })),
            ...dateFilters,
        ] as unknown as Record<string, unknown>[],
    });
    return toAssetRecords(await response.json());
};
